"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const callableInputDialog = ({ processor, functionId, entryVars: { title = '', description = '', mask = '', }, callbacks, executeProcesses, }) => {
    let newTitle = title;
    let newDescription = description;
    if ((0, valueIsRecord_1.default)(newTitle)) {
        newTitle = JSON.stringify(newTitle);
    }
    if ((0, valueIsRecord_1.default)(newDescription)) {
        newDescription = JSON.stringify(newDescription);
    }
    if (!(0, valueIsString_1.default)(newTitle)) {
        processor.root.alert('Error', 'Title must be a string');
        return;
    }
    if (!(0, valueIsString_1.default)(newDescription)) {
        processor.root.alert('Error', 'Description must be a string');
        return;
    }
    if (!(0, valueIsString_1.default)(mask)) {
        processor.root.alert('Error', 'Mask must be a string');
        return;
    }
    const onSubmit = (data) => {
        processor.root.openInputDialog({
            isOpened: false,
            onSubmit: undefined,
            onClose: undefined,
            onEmpty: undefined,
            title: '',
            description: '',
            mask: undefined,
        });
        executeProcesses(functionId, callbacks.onSubmit, `${data}`);
    };
    const onClose = () => {
        processor.root.openInputDialog({
            isOpened: false,
            onSubmit: undefined,
            onClose: undefined,
            onEmpty: undefined,
            title: '',
            description: '',
            mask: undefined,
        });
        executeProcesses(undefined, callbacks.onCancel);
    };
    const onEmpty = () => {
        processor.root.openInputDialog({
            isOpened: false,
            onSubmit: undefined,
            onClose: undefined,
            onEmpty: undefined,
            title: '',
            description: '',
            mask: undefined,
        });
        executeProcesses(undefined, callbacks.onEmpty);
    };
    processor.root.openInputDialog({
        isOpened: true,
        onSubmit,
        onClose,
        onEmpty,
        title: newTitle,
        description: newDescription,
        mask,
    });
};
exports.default = callableInputDialog;
